import React from 'react';
import PropTypes from 'prop-types';
import { Pencil } from 'lucide-react';
import { Button } from '@cargomatic/ui';

const EditButton = ({ disabled, onClick, title, id, dataTestId }) => {
  return (
    <Button
      id={id}
      variant="ghost"
      size="icon"
      className="h-8 w-8"
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      title={title}
      data-testid={dataTestId || 'editButton'}
    >
      <Pencil className="h-4 w-4" />
    </Button>
  );
};

EditButton.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  dataTestId: PropTypes.string,
};

EditButton.defaultProps = {
  disabled: false,
  title: '',
  onClick: () => {},
};

export default EditButton;
